module.exports = __webpack_public_path__ + "static/media/mx.4fb7c48f.svg";